"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Coin = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 19.979c2.48-.106 4.746-.604 6.481-1.385C21.354 17.75 23 16.38 23 14.5v-5c0-1.881-1.646-3.251-3.519-4.094C17.515 4.521 14.87 4 12 4s-5.515.521-7.481 1.406C2.646 6.25 1 7.62 1 9.5v5c0 1.881 1.646 3.251 3.519 4.094 1.735.78 4 1.279 6.481 1.385V20h2v-.021zM5.34 7.229C3.591 8.017 3 8.897 3 9.5c0 .604.592 1.484 2.34 2.27C6.991 12.514 9.345 13 12 13c2.653 0 5.008-.486 6.66-1.23C20.409 10.984 21 10.104 21 9.5c0-.604-.592-1.484-2.34-2.27C17.009 6.486 14.654 6 12 6s-5.008.486-6.66 1.23zM11 14.98a20.705 20.705 0 0 1-4-.55v2.933c1.168.327 2.526.546 4 .615V14.98zm-6.481-1.385c.156.07.316.138.481.204v2.811c-1.485-.743-2-1.546-2-2.109v-1.759c.465.328.983.612 1.519.853zM13 17.977v-2.998a20.68 20.68 0 0 0 4-.55v2.933c-1.168.327-2.526.546-4 .615zm6-1.368c1.485-.743 2-1.546 2-2.109v-1.759a9.254 9.254 0 0 1-1.519.853c-.156.07-.316.138-.481.204v2.811z", fill: fill || 'currentColor' })));
};
exports.default = Coin;
